export default __webpack_public_path__ + "static/media/latest-news-header-img-01.e87ec924.jpg";